import {
	getPXLBillingCreateRoute,
	getPXLBillingRoute,
	getPXLBillingsRoute,
	getPXLOrderRoute,
	getPXLOrdersRoute
}              from './factory/order';
import Orders
               from '../../../pages/order/Orders';
import Order
               from '../../../pages/order/Order';
import Billings
               from '../../../pages/billing/Billings';
import Create
               from '../../../pages/billing/Create';
import Billing from '../../../pages/billing/Billing';

/**
 * React Router v7 doesn't use 'exact' prop anymore.
 * Routes by default match 'exactly' unless there is a * or a splat parameter in the path.
 * For more details, see the React Router v7 documentation.
 */
const routes = [
	{
		path: getPXLBillingCreateRoute(),
		component: Create,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getPXLBillingRoute(),
		component: Billing,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getPXLBillingsRoute(),
		component: Billings,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getPXLOrdersRoute(),
		component: Orders,
		type: 'route',
		loginRequired: true,
	},
	{
		path: getPXLOrderRoute(),
		component: Order,
		type: 'route',
		loginRequired: true,
	},
];

export default routes;